import { Avatar, Box, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

import { CONTACT_LINKS } from "../constants/contactInfo"

const linkStyles = {
    dark: {
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 1.5,
        pr: 2,
        borderRadius: 2,
        textDecoration: "none",
        color: "inherit",
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.1)",
        transition: "background 0.2s ease, border-color 0.2s ease",
        "&:hover": {
            background: "rgba(255,255,255,0.08)",
            borderColor: "rgba(0, 163, 255, 0.45)",
        },
    },
    light: {
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 1.5,
        pr: 2,
        borderRadius: 2,
        textDecoration: "none",
        color: "#000435",
        background: "rgba(255,255,255,0.85)",
        border: "1px solid rgba(0, 4, 53, 0.08)",
        boxShadow: "0 8px 24px rgba(0, 4, 53, 0.04)",
        transition: "background 0.2s ease, border-color 0.2s ease, transform 0.2s ease",
        "&:hover": {
            background: "#fff",
            borderColor: "rgba(0, 163, 255, 0.45)",
            transform: "translateY(-1px)",
        },
    },
}

const captionStyles = {
    dark: { opacity: 0.65, fontWeight: 600 },
    light: { color: "text.secondary", fontWeight: 600 },
}

const ContactLinksList = ({ variant = "light" }) => (
    <Stack spacing={1.5}>
        {CONTACT_LINKS.map(({ href, icon: Icon, label, value, external }) => (
            <Box
                key={label}
                component={Link}
                to={href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                sx={linkStyles[variant]}
            >
                <Avatar
                    sx={{
                        width: 48,
                        height: 48,
                        bgcolor: "#00A3FF",
                        color: "#000435",
                        flexShrink: 0,
                    }}
                >
                    <Icon />
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                    <Typography variant="caption" sx={captionStyles[variant]}>
                        {label}
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={700} lineHeight={1.25}>
                        {value}
                    </Typography>
                </Box>
            </Box>
        ))}
    </Stack>
)

export default ContactLinksList
